/**
 * 사용자 주석 — 코드 값의 뜻을 편집기 F2 · 결과 표에서(docs/features/32-user-comment.md).
 * 정의는 주인만, 실행은 서버가 저장된 정의의 SQL 로만 한다(단일 SELECT · 행/시간 상한). 「시험 실행」 만 화면이 SQL 을 보낸다.
 */
const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';

async function call(method, path, body) {
    const res = await fetch(`${BASE_URL}/user-comments${path}`, {
        method,
        headers: body ? { 'Content-Type': 'application/json' } : undefined,
        body: body ? JSON.stringify(body) : undefined,
        credentials: 'include',
    });
    const j = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(j.error || `HTTP ${res.status}`);
        err.response = { status: res.status, data: j };
        throw err;
    }
    return j;
}

export const listDefs = () => call('GET', '/defs');
export const createDef = (name, spec) => call('POST', '/defs', { name, spec });
export const updateDef = (id, name, spec) => call('PUT', `/defs/${encodeURIComponent(id)}`, { name, spec });
export const deleteDef = (id) => call('DELETE', `/defs/${encodeURIComponent(id)}`);
export const fetchAreas = (connectionId) => call('POST', '/areas', { connectionId });
export const lookupValue = (connectionId, value, column) => call('POST', '/lookup', { connectionId, value, column: column || null });
export const lookupAreas = (connectionId, areas) => call('POST', '/lookup-areas', { connectionId, areas });
/** F2 — 이름(테이블·컬럼)의 DB 주석. tables = 편집기 SQL 의 테이블(있으면 그 테이블의 컬럼만) */
export const lookupDbComment = (connectionId, name, tables) => call('POST', '/db-comment', { connectionId, name, tables: tables || [] });
export const testQuery = (targetConnectionId, sql, kind) => call('POST', '/test', { targetConnectionId, sql, kind });

/** 조회할 연결의 기본값 — 서버 store.DEFAULT_TARGET 과 같다 */
export const DEFAULT_TARGET = 'conn_builtin_monitoring';

/** 이 연결에 켜진 정의가 있는가 */
export const activeFor = (defs, connectionId) => !!connectionId && (defs || []).some(d => d.spec && d.spec.enabled !== false && (d.spec.connectionIds || []).includes(connectionId));
